import { useNavigate, useParams } from "react-router-dom";
import React from "react";
import PageHeader from "@/custolink-views/asset_frontend/ui/layout/PageHeader";
import PageContent from "@/custolink-views/asset_frontend/ui/layout/PageContent";
import ResetPasswordSharedForm from "@/custolink-components/shared/ResetPasswordSharedForm";
import { Button } from "@/components/ui/Button";
import { useAssetFrontendDesign } from "@/custolink-views/asset_frontend/redesigns/assetFrontendDesign";
import ResetPasswordForEndUserDesign from "@/custolink-views/end_user/ResetPasswordForEndUserDesign";

export default function ResetPasswordForEndUser() {
  const { token } = useParams();
  const [done, setDone] = React.useState(false);
  const navigate = useNavigate();
  const newDesign = useAssetFrontendDesign();

  if (newDesign) {
    return <ResetPasswordForEndUserDesign />;
  }

  return (
    <>
      <PageHeader>
        <div className="flex items-center justify-between">
          <h3 className={"text-white"}>Reset Password</h3>
          <div></div>
        </div>
      </PageHeader>

      <PageContent>
        {!done && (
          <>
            <p className="font-semibold heading-text mb-4">
              Please enter a new password
            </p>
            <ResetPasswordSharedForm
              token={token ?? ""}
              toastDesignSwitch="asset"
              onDone={() => {
                setDone(true);
              }}
            />
          </>
        )}

        {done && (
          <div className="space-y-4">
            <h3 className="mt-4">Thank you</h3>
            <p className="font-semibold heading-text">
              Your password has been successfully reset.
            </p>
            <Button block variant="solid" type="button" onClick={()=>{
              navigate("/");
            }}>
              Continue
            </Button>
          </div>
        )}
      </PageContent>
    </>
  );
}
